import axios from "axios";
import mainApi from "../../api/mainApi";
import {
  BlsExportCW1Response,
  BlsExportResponse,
} from "../../interfaces/bl-export/blexport.interface";
import {
  DetailBlExport,
  DetailBLExportResponse,
} from "../../interfaces/bl-export/detail.blexport.interface";
import { CreateBLPayload } from "../../interfaces/bl-export/request.bl.interface";
import { middlewareApi } from "../../middlewares/middlewareApi";

const BLExportService = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET
     */
    getBlsExport: builder.query<
      BlsExportResponse,
      {
        filtro?: string;
        valor?: string;
        id_usuario?: number;
        page?: number;
        size?: number;
        creadosHace?: string;
        creados_api?: boolean;
      }
    >({
      queryFn: async ({
        filtro,
        valor,
        id_usuario,
        page,
        size,
        creadosHace,
        creados_api,
      }) => {
        try {
          const { data } = await mainApi.post<BlsExportResponse>(
            "bls/listarBlsEnhanced",
            {
              filtro,
              valor,
              id_usuario,
              page,
              size,
              creadosHace,
              creados_api,
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET
     */
    getDetailsBLExport: builder.query<
      DetailBLExportResponse,
      {
        id_bl: string;
        page: number;
        pageSize: number;
      }
    >({
      queryFn: async ({ id_bl, page, pageSize }) => {
        try {
          const { data } = await mainApi.post<DetailBLExportResponse>(
            "bls/detallesBL",
            {
              id_bl,
              page,
              pageSize,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET
     */
    downloadBlExport: builder.mutation<
      any,
      {
        fileName: string;
        id_bl: number;
        type: string;
      }
    >({
      queryFn: async ({ fileName, id_bl, type }) => {
        try {
          const { data } = await mainApi.get<any>("bls/descargarBl", {
            timeout: 120000,
            params: {
              fileName,
              id_bl,
              type,
            },
            responseType: "blob",
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @POST
     *
     */
    desactivarBl: builder.mutation<
      any,
      {
        id_bl: number;
      }
    >({
      queryFn: async ({ id_bl }) => {
        try {
          const { data } = await mainApi.post<any>("bls/desactivarBL", {
            id_bl,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @POST
     *
     */
    desactivarBlAdmin: builder.mutation<
      any,
      {
        id_bl: number;
      }
    >({
      queryFn: async ({ id_bl }) => {
        try {
          const { data } = await mainApi.post<any>("bls/desactivarBLAdmin", {
            id_bl,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET
     */
    searchContainers: builder.query<
      DetailBlExport[],
      {
        search: string;
      }
    >({
      queryFn: async ({ search }) => {
        try {
          const { data } = await mainApi.get<DetailBlExport[]>(
            "bls/searchContainers",
            {
              params: {
                search,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET get bl by code_booking
     */
    getBlByCodeBooking: builder.mutation<
      any,
      {
        cod_booking: string;
      }
    >({
      queryFn: async ({ cod_booking }) => {
        try {
          const { data } = await mainApi.get("bls/getBlByCodeBooking", {
            params: {
              cod_booking,
            },
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @GET get container by code
     */
    getContainerByCodeContainer: builder.mutation<
      any,
      {
        cod_container: string;
      }
    >({
      queryFn: async ({ cod_container }) => {
        try {
          const { data } = await mainApi.get(
            "/bls/getContainerByCodeContainer",
            {
              params: {
                cod_container,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @POST donwload XLSX bls
     */
    donwloadXlxsBls: builder.mutation<
      any,
      {
        filtro?: string;
        valor?: string;
        id_usuario?: number;
        page?: number;
        size?: number;
        creadosHace?: string;
        creados_api?: boolean;
      }
    >({
      queryFn: async ({
        filtro,
        valor,
        id_usuario,
        page,
        size,
        creadosHace,
        creados_api,
      }) => {
        try {
          const { data } = await mainApi.post(
            "bls/exportBlsExcel",
            {
              filtro,
              valor,
              id_usuario,
              page,
              size,
              creadosHace,
              creados_api,
            },
            {
              responseType: "blob",
            }
          );
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @GET Download carta
     */
    downloadCarta: builder.mutation<
      any,
      {
        fileName: string;
      }
    >({
      queryFn: async ({ fileName }) => {
        try {
          const { data } = await mainApi.get("bls/descargarCartaGastos", {
            params: {
              fileName,
            },
            responseType: "blob",
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @POST create new bl
     */
    createBl: builder.mutation<any, CreateBLPayload>({
      queryFn: async (payload) => {
        try {
          const { data } = await mainApi.post("bls/news", payload);
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @POST update BL
     */
    updateBl: builder.mutation<any, CreateBLPayload>({
      queryFn: async (payload) => {
        try {
          const { data } = await mainApi.post("bls/updateBl", payload);
          return { data };
        } catch (error: any) {
          return { error: error.response.data.msg || "ERROR" };
        }
      },
    }),
    /**
     * @POST get Bls CW1
     */
    getBlsCW1: builder.query<
      BlsExportCW1Response,
      {
        page?: number;
        size?: number;
        cod_booking?: string;
        id_bl?: number;
      }
    >({
      queryFn: async ({ cod_booking, id_bl, page, size }) => {
        try {
          const { data } = await mainApi.get("bls/getBlsCW1", {
            params: { cod_booking, id_bl, page, size },
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @POST Upload bl document
     */
    uploadBlDocument: builder.mutation<
      any,
      {
        id_bl: number;
        file: File;
        file_type: string;
      }
    >({
      queryFn: async ({ file, file_type, id_bl }) => {
        const formdata = new FormData();
        formdata.append("file", file);

        try {
          const { data } = await mainApi.post(`bls/${id_bl}/upload`, formdata, {
            params: {
              file_type,
            },
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     *
     */
    enableCreateApi: builder.mutation<
      any,
      {
        cod_booking: string;
        tipo: string;
      }
    >({
      queryFn: async ({ cod_booking, tipo }) => {
        try {
          const headers = {
            "x-token": localStorage.getItem("token") || "",
          };
          const { data } = await axios.post(
            "http://54.221.78.172:4000/api/embarques/bypass",
            {
              cod_booking,
              tipo,
            },
            {
              headers: headers,
            }
          );
          return { data };
        } catch (error: any) {
          return {
            error:
              error?.response?.data?.message || ("Error. Intente luego" as any),
          };
        }
      },
    }),
  }),
});

export const {
  useGetBlsExportQuery,
  useLazyGetBlsExportQuery,
  useGetDetailsBLExportQuery,
  useDownloadBlExportMutation,
  useDesactivarBlMutation,
  useDesactivarBlAdminMutation,
  useSearchContainersQuery,
  useGetBlByCodeBookingMutation,
  useGetContainerByCodeContainerMutation,
  useDonwloadXlxsBlsMutation,
  useDownloadCartaMutation,
  useCreateBlMutation,
  useGetBlsCW1Query,
  useLazyGetBlsCW1Query,
  useUpdateBlMutation,
  useUploadBlDocumentMutation,
  useEnableCreateApiMutation,
} = BLExportService;
